// extracted by mini-css-extract-plugin
export var dismissOverlay = "_bb-b";
export var interactivePassthrough = "_bb-3";
export var modal = "_bb-d";
export var modalBackdrop = "_bb-c";
export var modalBody = "_bb-j";
export var modalDescription = "_bb-m";
export var modalEnter = "_bb-e";
export var modalFooter = "_bb-n";
export var modalHeaderText = "_bb-h";
export var modalIconCircle = "_bb-i";
export var modalIconHeader = "_bb-g";
export var modalImage = "_bb-f";
export var modalSectionLabel = "_bb-k";
export var modalTitle = "_bb-l";
export var pulse = "_bb-1";
export var pulseBorder = "_bb-2";
export var spotlight = "_bb-0";
export var tooltip = "_bb-4";
export var tooltipButtons = "_bb-9";
export var tooltipDescription = "_bb-6";
export var tooltipFooter = "_bb-7";
export var tooltipInteractivePill = "_bb-a";
export var tooltipStepIndicator = "_bb-8";
export var tooltipTitle = "_bb-5";